<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="18" :md="14">
        <div class="news">
          <h1>度芽体温贴亮相苏州国际精英创业周喜获青睐</h1>
          <p>
              7月10-112日,第十届苏州国际精英创业周顺利举行,苏州飞康生物医药有限公司(简称:苏州飞康)携代表产品“度芽智能体温贴”分别亮相于苏州“好品秀”新产品新技术发布活动、太仓分会“秀工场”活动。
          </p>
          <img src="@/assets/images/information/0713_1.jpg" alt="" />
          <p class="imgtxt">苏州好品秀发布活动现场</p>
          <img src="@/assets/images/information/0713_2.jpg" alt="" />
          <p class="imgtxt">度芽体温贴现场展示</p>
          <p>
              苏州“好品秀”发布现场,度芽展台前咨询体验的人络绎不绝,大家都对这样一款可穿戴的体温计表示好奇,了解到仅仅创可贴大小的体温贴,即可在宝宝发烧时实现24小时持续监测、高低温警报、远程实时共享时,一致表示产品很高科技,也特别实用。现场不少有宝宝的家庭对此更是深有感触,直接询问度芽的购买方式。
          </p>
          <img src="@/assets/images/information/0713_3.jpg" alt="" />
          <p class="imgtxt">度芽参演情景剧《奶爸带娃日》</p>
          <img src="@/assets/images/information/0713_4.jpg" alt="" />
          <p class="imgtxt">度芽受邀进行产品发布</p>
          <p>
              在太仓分会“秀工场”展厅,度芽智能体温贴也受到了参观人员的青睐,纷纷前来体验,并对度芽的贴心功能大表认可。为期两天的参展中,度芽智能体温贴受到了诸多媒体的关注和报道,人民网江苏频道对度芽智能体温贴等一批参展的高新技术企业新品,赞其代表了“苏州制造”的最新风向,太仓日报表示度芽体温贴打造出体温测量界的“黑科技”。
          </p>
          <img src="@/assets/images/information/0713_5.jpg" alt="" />
          <p class="imgtxt">太仓秀工场度芽展柜</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "180713",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.news {
  margin-top: 90px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  img{
    width:380px;
    height: auto;
    
  }
  .imgtxt {
    text-align: center;
    margin-top: 5px;
  }
  p {
    line-height: 28px;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  h1,
  h2 {
    margin-top: 20px;
  }
}
</style>
